import { CloseOutlined } from '@ant-design/icons'
import { Modal } from 'antd'
import { submissionTranslations } from '../../../components/SubmissionV2/translations'
import { useTrackModalOpen } from '../../../utils/useTrackModalOpen'
import { PageLang } from '../pageLang'

// This page manages its own lang state (not the app-wide useLang(), which would
// also override the page's font-family as a side effect) - just index the same
// shared translation data by that local lang instead.
const TITLE: Record<PageLang, string> = {
  EN: 'Compare HAUP plans',
  TH: 'เปรียบเทียบแผนของ HAUP',
}

export interface ComparePlansModalProps {
  lang: PageLang
  open: boolean
  onClose: () => void
}

export const ComparePlansModal = ({ lang, open, onClose }: ComparePlansModalProps) => {
  const t = submissionTranslations[lang].listing.proIntro.planDetails
  useTrackModalOpen('Login Page Compare Plans Modal Opened', open)

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      width={490}
      bodyStyle={{ padding: '24px', fontFamily: 'Poppins, sans-serif' }}
      style={{ borderRadius: '8px', top: 40 }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px' }}>
        <h2 style={{ fontSize: '18px', fontWeight: 600, color: '#212427', margin: 0 }}>
          {TITLE[lang]}
        </h2>
        <CloseOutlined style={{ cursor: 'pointer', color: '#666' }} onClick={onClose} />
      </div>

      <div
        style={{
          display: 'flex',
          borderRadius: '12px',
          overflow: 'hidden',
          border: '1px solid #E4E7EC',
        }}
      >
        <div style={{ flex: 1.3 }}>
          <div style={{ height: '52px', display: 'flex', alignItems: 'center', padding: '0 10px' }}>
            <span
              style={{
                fontSize: '10.5px',
                fontWeight: 600,
                color: '#8C97A7',
                letterSpacing: '0.4px',
                textTransform: 'uppercase',
              }}
            >
              {t.featureListLabel}
            </span>
          </div>
          {t.featureRows.map((row, i) => (
            <div
              key={i}
              style={{
                minHeight: '56px',
                display: 'flex',
                alignItems: 'center',
                padding: '8px 10px',
                borderTop: '1px solid #EEF0F3',
                fontSize: '12px',
                color: '#212427',
              }}
            >
              {row.label}
            </div>
          ))}
        </div>

        <div style={{ flex: 1 }}>
          <div
            style={{
              height: '52px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <span
              style={{
                fontSize: '10.5px',
                fontWeight: 700,
                letterSpacing: '0.4px',
                color: '#8C97A7',
              }}
            >
              {t.starterColLabel}
            </span>
          </div>
          {t.featureRows.map((row, i) => (
            <div
              key={i}
              style={{
                minHeight: '56px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                padding: '8px',
                borderTop: '1px solid #EEF0F3',
                fontSize: '12px',
                color: '#212427',
              }}
            >
              {row.starter}
            </div>
          ))}
        </div>

        <div style={{ flex: 1, backgroundColor: '#041F3E' }}>
          <div
            style={{
              height: '52px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <span
              style={{ fontSize: '10.5px', fontWeight: 700, letterSpacing: '0.4px', color: '#fff' }}
            >
              {t.proColLabel}
            </span>
          </div>
          {t.featureRows.map((row, i) => (
            <div
              key={i}
              style={{
                minHeight: '56px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                padding: '8px',
                borderTop: '1px solid rgba(255,255,255,0.12)',
                fontSize: '12px',
                color: '#fff',
              }}
            >
              {row.pro}
            </div>
          ))}
        </div>
      </div>
    </Modal>
  )
}

export default ComparePlansModal
